import {
    createColumnDatetime,
    createColumnInput,
    createColumnInputNumber,
    createColumnSelect,
    createColumnTreeSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { putField } from "../../../../utils/form";
import { callFeeStatus, callFeeType, callRequestDoc } from "../../fee/fee/fee.logic";

export const callDepartment = () => store.dispatch("resource/v1/master/department/cacheFindAllWithChildrenType", { type: "main" });

export const createColumns = ({ state }) => {
    const feeStatusApprove = state.feeStatuses.find(d => d.key === "approve");
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.feeStatement.feeCode"), dataIndex: "feeCode", align: "center" }),
        createColumnSelect({
            title: () => i18n.global.t("model.feeStatement.refType"),
            dataIndex: "refType.value",
            inputProp: () => ({ list: callFeeType, optLabel: "value" }),
            align: "center",
            search: {
                name: "refType.id"
            }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnTreeSelect({
            title: () => i18n.global.t("views.report.department"),
            dataIndex: "refRequest.refDepartment.nameTh",
            inputProp: () => ({
                list: callDepartment,
                renderLabel: ({ item }) => (
                    <div>
                        {item.fullCode} : {item.nameTh}
                    </div>
                ),
                filterWhere: ({ value }) => [
                    { name: "fullCode", operator: "like", value },
                    { logic: "OR", name: "nameTh", operator: "like", value }
                ],
                treeDefaultExpandAll: true
            }),
            search: { name: "refRequest.refDepartment.id" },
            width: 200
        }),
        createColumnDatetime({
            title: () => i18n.global.t("model.feeStatement.payDatetime"),
            dataIndex: "payDatetime",
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("views.report.requestDocType"),
            dataIndex: "refRequest.refRequestDoc.value",
            inputProp: () => ({ list: callRequestDoc, optLabel: "value" }),
            align: "center",
            search: {
                name: "refRequest.refRequestDoc.id"
            }
        }),
        createColumnInput({ title: () => i18n.global.t("model.feeStatement.customerName"), dataIndex: "customerName", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.feeStatement.requestNumber1"), dataIndex: "requestNumber1", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.feeStatement.requestNumber2"), dataIndex: "requestNumber2", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.feeStatement.receiptCode"), dataIndex: "receiptCode", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.feeStatement.refOfficer"), dataIndex: "refOfficer.fullNameTh", align: "center" }),
        createColumnInputNumber({ title: () => i18n.global.t("model.feeStatement.netAmount"), dataIndex: "netAmount", align: "center" }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callFeeStatus, optLabel: "value" }),
            search: { name: "refStatus.id", field: { searchValue: feeStatusApprove } },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
